import { PseudoElementSelector } from "./pseudo-element.js";
/**
 * {@link https://drafts.csswg.org/css-pseudo/#selectordef-after}
 */
export class After extends PseudoElementSelector {
    static of() {
        return new After();
    }
    constructor() {
        super("after");
    }
    *[Symbol.iterator]() {
        yield this;
    }
}
(function (After) {
    After.parse = PseudoElementSelector.parseLegacy("after", After.of);
})(After || (After = {}));
//# sourceMappingURL=after.js.map